import { post, get } from '@integec/fetch-task'

export const getAeciUnitHourly = targetInfo => ({ unitId, date }) =>
  get(targetInfo, `aeci/unit-hourly?unitId=${unitId}&date=${date}`)

export const getAeciHourlyEvents = targetInfo => ({ unitId, date }) =>
  get(targetInfo, `aeci/hourly-event?unitId=${unitId}&date=${date}`)

export const saveAeciHourlyEvents = targetInfo => data =>
  post(targetInfo, 'aeci/hourly-event')(data)

export const saveRepeatAeciHourlyEvents = targetInfo => data =>
  post(targetInfo, 'aeci/hourly-event/repeat')(data)

export const deleteAeciHourlyEvents = targetInfo => data =>
  post(targetInfo, 'aeci/hourly-event/delete')(data)

export const moveAeciHourlyEvent = targetInfo => data =>
  post(targetInfo, 'aeci/hourly-event/move')(data)

export const updateAeciEventComment = targetInfo => data =>
  post(targetInfo, 'aeci/hourly-event/update-comment')(data)

export const validateAndUpdateAeciAvailCap = targetInfo => data =>
  post(targetInfo, 'aeci/hourly-event/update-availcap')(data)

export const getAeciPreviewEvent = targetInfo => ({
  unitId,
  startDate,
  startHour,
  endDate,
  endHour,
}) =>
  get(
    targetInfo,
    `aeci/preview-event?unitId=${unitId}&startDate=${startDate}&startHour=${startHour}&endDate=${endDate}&endHour=${endHour}`
  )

export const submitAeciHourlyEvents = targetInfo => ({
  unitId,
  startDate,
  startHour,
  endDate,
  endHour,
  ampCodes,
}) =>
  post(
    targetInfo,
    `aeci/hourly-event/submit?unitId=${unitId}&startDate=${startDate}&startHour=${startHour}&endDate=${endDate}&endHour=${endHour}`
  )(ampCodes || {})

export const checkAeciLock = targetInfo => ({ unitId, date }) =>
  get(targetInfo, `aeci/check-lock?unitId=${unitId}&date=${date}`)

export const getAeciEventMonthlyLock = targetInfo => ({
  unitId,
  year,
  month,
}) =>
  get(
    targetInfo,
    `aeci/event-monthly-lock?unitId=${unitId}&year=${year}&month=${month}`
  )

export const saveAeciEventMonthlyLock = targetInfo => data =>
  post(targetInfo, 'aeci/event-monthly-lock')(data)

export const saveAeciDrl = targetInfo => data =>
  post(targetInfo, 'aeci/save-drl')(data)

export const validateAndUpdateAeciDrl = targetInfo => data =>
  post(targetInfo, 'aeci/drl/update')(data)
